var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "protocol_search_container"
  }, [_c('div', {
    staticClass: "protocol_view_container"
  }, [_c('div', {
    staticClass: "view_top_btn"
  }, [_c('a', {
    staticClass: "back_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToList');
      }
    }
  }, [_vm._v("목록으로")])]), _c('div', {
    staticClass: "view_head"
  }, [_c('div', {
    staticClass: "protocol_search_item"
  }, [_c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "txt_cont"
  }, [_c('div', {
    staticClass: "tit_label"
  }, [_vm.uniqueNumber ? _c('span', {
    staticClass: "label_color color_01"
  }, [_vm._v(_vm._s(_vm.uniqueNumber))]) : _c('span', {
    staticClass: "label_color color_01"
  }, [_vm._v(_vm._s("공정도"))]), _c('span', {
    staticClass: "label_gray"
  }, [_vm._v(_vm._s(`${_vm.fieldName.split(">").join(" / ")}`))])]), _c('div', {
    staticClass: "tit_link",
    domProps: {
      "innerHTML": _vm._s(_vm.processName)
    }
  })]), _c('div', {
    staticClass: "img_cont"
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    staticClass: "template",
    attrs: {
      "src": `data:image/jpeg;base64,${_vm.thumbnail}`
    }
  })])])]), _c('div', {
    staticClass: "bottom_info"
  }, [_c('ul', {
    staticClass: "user_set"
  }, [_c('li', [_vm._v(_vm._s(_vm.lastEditDate) + " ")]), _c('li', [_vm._v("책임작성자 : " + _vm._s(_vm.userData.name))]), _vm.collaborators.length > 1 ? _c('li', [_vm._v("공동작성자 : "), _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    return collaboratorKey > 0 ? _c('span', {
      key: collaboratorKey
    }, [_vm._v(_vm._s(`${collaboratorKey != 1 ? " ," + collaborator.name : collaborator.name}`))]) : _vm._e();
  })], 2) : _vm._e()]), _c('ul', {
    staticClass: "btn_set"
  }, [_c('li', [_c('a', {
    staticClass: "writer_more_btn",
    class: _vm.writerListActive ? 'on' : null,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        _vm.writerListActive = !_vm.writerListActive;
      }
    }
  }, [_vm._v("작성자 더보기")])]), _vm.thisMyPage ? _c('li', [_vm.thisMyPage ? _c('a', {
    staticClass: "editor_move_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessEditor');
      }
    }
  }, [_vm._v("에디터로 이동 ")]) : _vm._e()]) : _vm._e()])])]), _c('ul', {
    staticClass: "protocol_writer_list",
    class: _vm.writerListActive ? 'on' : null
  }, _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    var _collaborator$email, _collaborator$mobile, _collaborator$company, _collaborator$positio, _collaborator$fax, _collaborator$company2;

    return _c('li', {
      key: collaboratorKey
    }, [_c('ul', {
      staticClass: "writer_info"
    }, [_c('li', {
      staticClass: "user_name"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v(_vm._s(collaborator.name))]), _c('span', [_vm._v(_vm._s(`${collaboratorKey == 0 ? "책임작성자" : "공동작성자"}`))])])]), _c('li', [_c('label', [_vm._v("이메일")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$email = collaborator.email) === null || _collaborator$email === void 0 ? void 0 : _collaborator$email.length) > 0 ? collaborator.email : "-"}`))])]), _c('li', [_c('label', [_vm._v("전화번호")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$mobile = collaborator.mobile) === null || _collaborator$mobile === void 0 ? void 0 : _collaborator$mobile.length) > 0 ? collaborator.mobile : "-"}`))])]), _c('li', [_c('label', [_vm._v("소속")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$company = collaborator.companyName) === null || _collaborator$company === void 0 ? void 0 : _collaborator$company.length) > 0 ? collaborator.companyName : "-"}`))])]), _c('li', [_c('label', [_vm._v("직책")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$positio = collaborator.position) === null || _collaborator$positio === void 0 ? void 0 : _collaborator$positio.length) > 0 ? collaborator.position : "-"}`))])]), _c('li', [_c('label', [_vm._v("팩스")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$fax = collaborator.fax) === null || _collaborator$fax === void 0 ? void 0 : _collaborator$fax.length) > 0 ? collaborator.fax : "-"}`))])]), _c('li', [_c('label', [_vm._v("직장전화번호")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$company2 = collaborator.companyPhone) === null || _collaborator$company2 === void 0 ? void 0 : _collaborator$company2.length) > 0 ? collaborator.companyPhone : "-"}`))])])])]);
  }), 0)]), _c('div', {
    staticClass: "view_body"
  }, [_c('div', {
    staticClass: "protocol_map"
  }, [_c('div', {
    staticClass: "editor",
    attrs: {
      "id": "preview-process"
    }
  }), _c('editorOptions', {
    attrs: {
      "diagram": _vm.diagram
    }
  }, [_c('div', {
    staticClass: "overviewWrap"
  }), _c('div', {
    staticClass: "overview_wrap"
  }, [_c('div', {
    staticClass: "overview",
    class: {
      on: _vm.overviewStatus
    }
  }, [_c('div', {
    staticClass: "title_area"
  }, [_c('strong', {
    staticClass: "tit"
  }, [_vm._v("Map")])]), _c('div', {
    staticClass: "editor_overview",
    attrs: {
      "id": "editor-overview"
    }
  })])])])], 1)])]), _c('IncludedProtocols', {
    attrs: {
      "inProcessId": _vm.inProcessId,
      "lastEditDate": _vm.lastEditDate,
      "active": _vm.includedProtocolsActive,
      "publishingActive": _vm.publishingActive
    },
    on: {
      "goToDetail": _vm.goToDetail,
      "close": function ($event) {
        _vm.includedProtocolsActive = false;
      }
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ico"
  }, [_c('span', {
    staticClass: "icon_img"
  })]);

}]

export { render, staticRenderFns }